import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { LayoutLegacy } from "@silvertours/front-legacy-entities";
import { Button } from "@silvertours/front-shared";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { useTranslations } from "next-intl";
import { useSiteInfo } from "@silvertours/front-entities";
import { ContactText, PhoneNumberContainer, PhoneNumberIcon } from "./SupportInfo.styles";
var ContactUs = function() {
    var t = useTranslations("features.supportInfoLegacy");
    var ref = useSiteInfo(), featureToggles = ref.settings.featureToggles;
    if (featureToggles.hideInfoline) {
        return null;
    }
    var handleClick = function() {
        window.location.assign("tel:".concat(t("phoneNumber.link")));
    };
    return /*#__PURE__*/ _jsx(LayoutLegacy.PlainSegment, {
        id: "contact-us",
        children: /*#__PURE__*/ _jsxs(PhoneNumberContainer, {
            children: [
                /*#__PURE__*/ _jsxs(ContactText, {
                    children: [
                        /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                            children: /*#__PURE__*/ _jsx("b", {
                                children: t("contactUs.title")
                            })
                        }),
                        /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                            children: t("contactUs.text")
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "secondary",
                    icon: /*#__PURE__*/ _jsx(PhoneNumberIcon, {}),
                    onClick: handleClick,
                    children: t("phoneNumber.display")
                })
            ]
        })
    });
};
export { ContactUs };
